import { Form, Input } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { UserPermission } from './type';

interface Props {
  record: UserPermission;
  dataIndex: string;
  title: string;
  children: '';
  editable: boolean;
  restProps: '';
  editing: number;
}
interface State {
  editing: boolean;
  turns: string;
  isUpdate: boolean;
}

const EditTableContext = React.createContext(Form);

class EditTableCell extends React.Component<Props, State> {
  public form: any;
  public input: any;
  constructor(props: Props) {
    super(props);
    this.state = {
      editing: false,
      turns: '',
      isUpdate: false,
    };
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
        this.setState({ turns: this.input.props.value });
      }
    });
  };

  save = e => {
    this.form.validateFields((error, values) => {
      if (error && error[e.currentTarget.id]) {
        return;
      }
      this.toggleEdit();
    });
  };

  getMuTurns = value => {
    this.setState({ turns: value, isUpdate: true });
  };

  renderCell = form => {
    this.form = form;
    const { getFieldDecorator } = form;
    const { children, dataIndex, record, title, editing } = this.props;
    return editing ? (
      <Form.Item style={{ margin: 0 }}>
        {getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `${title} is required.`,
            },
          ],
          initialValue: record[dataIndex],
        })(<Input />)}
      </Form.Item>
    ) : (
      children
    );
  };

  render() {
    const { editable, dataIndex, title, record, children, ...restProps } = this.props;
    return <td {...restProps}>{<EditTableContext.Consumer>{this.renderCell}</EditTableContext.Consumer>}</td>;
  }
}

const EditableRowStyle = styled.tr`
  :hover {
    .editable-cell-value-wrap {
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      padding: 4px 11px;
    }
  }
`;

// eslint-disable-next-line react/prop-types
const EditableRow = ({ form, index, ...props }) => {
  return (
    <EditTableContext.Provider value={form}>
      <EditableRowStyle {...props} />
    </EditTableContext.Provider>
  );
};
const EditTableFormRow = Form.create()(EditableRow);

export { EditTableContext, EditTableCell, EditTableFormRow };



// WEBPACK FOOTER //
// ./src/screens/rolePermission/EditTableCell.tsx